export default "<p>\n  task-term-simplification works!\n</p>\n"